// src/pages/dashboard/TopBar.jsx
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import NotificationBell from './topBar/NotificationBell';
import CoinBalance from './topBar/CoinBalance';

import LogoSvg from '../../assets/logo.svg';

import Fig from '../../assets/logo.svg';

import { getAuthHeaders, getEffectiveRole, getTokenRole, setRoleViewOverride, urlMap } from '../../utils';


import { withNotifications } from '../../state/notifications/NotificationContext';

const canImpersonateRole = (role) => role === 'publisher' || role === 'admin';
const normalizeEffectiveRoleOverride = (value) => (value === 'publisher' || value === 'user' ? value : null);
const resolveRoleView = (tokenRole, savedOverride) => {
  if (tokenRole === 'publisher') return savedOverride === 'user' ? 'user' : 'publisher';
  if (tokenRole === 'admin') return savedOverride === 'publisher' || savedOverride === 'user' ? savedOverride : 'admin';
  return tokenRole || 'user';
};
const roleViewToEffectiveRoleOverride = (tokenRole, roleView) => {
  if (tokenRole === 'publisher') return roleView === 'user' ? 'user' : 'publisher';
  if (tokenRole === 'admin') return roleView === 'publisher' || roleView === 'user' ? roleView : null;
  return null;
};

class TopBar extends Component {
  state = {
    role: getTokenRole() || 'user',
    roleView: getEffectiveRole() || 'user',
    roleViewSaveState: 'idle',
    profileSnapshot: null,
  };

  isMountedFlag = false;

  componentDidMount() {
    this.isMountedFlag = true;
    this.loadRoleView();
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
  }

  loadRoleView = async () => {
    const fallbackRole = getTokenRole() || 'user';
    try {
      const res = await fetch(urlMap.profile, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        credentials: 'include',
      });
      const payload = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(payload?.error || `HTTP_${res.status}`);

      const role = payload?.role || fallbackRole;
      const serverEffectiveRole = normalizeEffectiveRoleOverride(payload?.user_preferences?.effectiveRole);
      const roleView = resolveRoleView(role, serverEffectiveRole);
      setRoleViewOverride(roleViewToEffectiveRoleOverride(role, roleView));

      if (!this.isMountedFlag) return;
      this.setState({
        role,
        roleView,
        roleViewSaveState: 'idle',
        profileSnapshot: payload,
      });
    } catch {
      if (!this.isMountedFlag) return;
      this.setState({
        role: fallbackRole,
        roleView: resolveRoleView(fallbackRole, normalizeEffectiveRoleOverride(getEffectiveRole())),
      });
    }
  };

  handleRoleViewChange = async (event) => {
    const { role, roleView, profileSnapshot } = this.state;
    if (!canImpersonateRole(role)) return;

    const requestedRoleView = String(event?.target?.value || '').toLowerCase();
    let nextRoleView = role;
    if (role === 'publisher') {
      nextRoleView = requestedRoleView === 'user' ? 'user' : 'publisher';
    } else if (role === 'admin') {
      nextRoleView = requestedRoleView === 'publisher' || requestedRoleView === 'user' ? requestedRoleView : 'admin';
    }
    if (nextRoleView === roleView) return;

    const previousRoleView = roleView;
    const nextOverride = roleViewToEffectiveRoleOverride(role, nextRoleView);
    const previousOverride = roleViewToEffectiveRoleOverride(role, previousRoleView);

    this.setState({ roleView: nextRoleView, roleViewSaveState: 'saving' });
    setRoleViewOverride(nextOverride);

    try {
      const snapshot = profileSnapshot || {};
      const userPreferences = snapshot?.user_preferences && typeof snapshot.user_preferences === 'object'
        ? snapshot.user_preferences
        : {};

      const res = await fetch(urlMap.profile, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        credentials: 'include',
        body: JSON.stringify({
          name: snapshot?.name || '',
          phone_number: snapshot?.phone_number || '',
          public_url: snapshot?.public_url || null,
          user_preferences: {
            ...userPreferences,
            effectiveRole: nextOverride,
          },
        }),
      });
      const payload = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(payload?.error || `HTTP_${res.status}`);

      if (!this.isMountedFlag) return;
      this.setState({
        roleViewSaveState: 'saved',
        profileSnapshot: {
          ...snapshot,
          ...payload,
          user_preferences: {
            ...userPreferences,
            ...(payload?.user_preferences || {}),
            effectiveRole: nextOverride,
          },
        },
      });

      // Reload so route-level and data-level role guards pick up the new role view immediately.
      window.setTimeout(() => {
        if (this.isMountedFlag) {
          window.location.reload();
        }
      }, 250);

      window.setTimeout(() => {
        if (this.isMountedFlag && this.state.roleViewSaveState === 'saved') {
          this.setState({ roleViewSaveState: 'idle' });
        }
      }, 1200);
    } catch {
      setRoleViewOverride(previousOverride);
      if (!this.isMountedFlag) return;
      this.setState({ roleView: previousRoleView, roleViewSaveState: 'error' });
    }
  };

  render() {
      const pathname = typeof window !== 'undefined' ? String(window.location.pathname || '') : '';
      const isAdminRoute = pathname.startsWith('/admin/panel');
      const isProfileRoute = pathname.startsWith('/profile');
      const isHomeRoute = pathname === '/home';
      const isProjectLibraryRoute = /^\/project\/[^/]+\/library\/?$/.test(pathname);
      const isChapterRoute = /^\/project\/[^/]+\/(?:library\/)?chapter\/[^/]+\/?$/.test(pathname);
      const useProjectTitleTypography = isAdminRoute || isProfileRoute;
    const {
      pageTitle,
      pageSubtitle,
      pageBadge,
      backTo,
      backLabel = 'Back to work',
      onBack,
    } = this.props;
    const { role, roleView, roleViewSaveState } = this.state;
    const isAdmin = role === 'admin';
    const showRoleView = canImpersonateRole(role);
    const isEffectiveAdmin = getEffectiveRole() === 'admin';
    const showBackButton = Boolean(backTo || onBack) && !(isEffectiveAdmin && isHomeRoute);
    const showPageHeader = Boolean(pageTitle);
    const { notificationsApi } = this.props;
    const {
      items = [],
      unreadCount = 0,
      remove,
      clear,
      markRead,
      markAllRead,
    } = notificationsApi || {};

    

    return (
      <header className="topbar" role="banner">
        {/* Left: branding */}
        <div className="topbar-left">
          {showBackButton ? (
            onBack ? (
              <button type="button" className="topbar-back-btn" onClick={onBack} aria-label={backLabel}>
                ← {backLabel}
              </button>
            ) : (
              <Link to={backTo} className="topbar-back-btn" aria-label={backLabel}>
                ← {backLabel}
              </Link>
            )
          ) : (
            <Link to="/home" className="brand">
              <img src={LogoSvg} alt="StoryClub logo" className="brand-logo" />
              <span> storyclub.ai </span>
            </Link>
          )}
          {showRoleView && (
            <div className="topbar-role-view">
              <label htmlFor="topbar-role-view" className="topbar-role-view__label">Role</label>
              <select
                id="topbar-role-view"
                className="topbar-role-view__select"
                value={roleView || role || 'user'}
                onChange={this.handleRoleViewChange}
                aria-label="Role"
              >
                {isAdmin && <option value="admin">Admin</option>}
                <option value="publisher">Publisher</option>
                <option value="user">Writer</option>
              </select>
              {roleViewSaveState === 'saving' && <span className="topbar-role-view__status">Saving...</span>}
              {roleViewSaveState === 'saved' && <span className="topbar-role-view__status topbar-role-view__status--saved">Saved</span>}
              {roleViewSaveState === 'error' && <span className="topbar-role-view__status topbar-role-view__status--error">Error</span>}
            </div>
          )}
        </div>

        {/* Center (reserved for global search / page heading) */}
        <div className={`topbar-center${(isProjectLibraryRoute || isChapterRoute) ? ' topbar-center--project' : ''}`}>
          {isProjectLibraryRoute ? (
            <div id="topbar-project-title-slot" className="topbar-project-title-slot" aria-label="Project title" />
          ) : isChapterRoute ? (
            <div id="topbar-chapter-title-slot" className="topbar-chapter-title-slot" aria-label="Chapter title" />
          ) : showPageHeader ? (
            <div className="topbar-page-head" aria-label={`${pageTitle} page header`}>
              <div className="topbar-page-title-row">
                <h1 className={`topbar-page-title${useProjectTitleTypography ? ' topbar-page-title--project-font' : ''}`}>{pageTitle}</h1>
                {pageBadge ? <span className="topbar-page-badge">{pageBadge}</span> : null}
              </div>
              {pageSubtitle ? <p className="topbar-page-subtitle">{pageSubtitle}</p> : null}
            </div>
          ) : null}
        </div>


        {/* Right: utilities */}
        <div className="topbar-right">
          <CoinBalance />
          <NotificationBell
            count={unreadCount}
            items={items}
            onRemove={remove}
            onClearAll={clear}
            onMarkRead={markRead}
            onMarkAllRead={markAllRead}
            // omit viewAllHref to avoid a missing route/redirect loop
          />
          <Link to="/profile" className={`profile-link ${isProfileRoute ? 'is-active' : ''}`} aria-label="Profile">
            <div className="avatar-xs" aria-hidden>
              <svg
                className="profile-icon"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.8" />
                <path
                  d="M5 18C5.8 15.1 8.2 13.5 12 13.5C15.8 13.5 18.2 15.1 19 18"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <span className="profile-name"></span>
          </Link>
        </div>
      </header>
    );
  }
}

export default withNotifications(TopBar);
